import React from "react";
import { object } from "prop-types";
import { format } from "date-fns";
import get from "lodash/get";

import "./live-blog-timestamp.m.css";

const LiveBlogTime = ({ card }) => {
  const timeStamp = card["card-added-at"];
  const isKeyEvent = get(card, ["metadata", "attributes", "key-event"], false);

  return (
    <div styleName="wrapper">
      <div styleName={`text timestamp ${isKeyEvent ? "with-event" : ""}`}>{format(timeStamp, "h:mm a, dd MMM")}</div>
      {isKeyEvent && <div styleName="text event">KEY EVENT</div>}
    </div>
  );
};

LiveBlogTime.propTypes = {
  card: object
};

export default LiveBlogTime;
